export default "__VITE_ASSET__iSG0lsp$__"